import styled from 'styled-components'
// import { stylevars } from '@Common/StyleVars'

export const StyledContainer = styled.div`
  padding: 0rem;
`